// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ja","title":"Ka"};